import PropTypes from 'prop-types';

const HeaderImage = ({ candidates }) => (
  <div className="relative mb-4 overflow-hidden rounded-lg">
    <img 
      src={candidates} 
      alt="Presidential candidates" 
      className="w-full h-auto"
    />
  </div>
);

HeaderImage.propTypes = {
  candidates: PropTypes.string
};

export default HeaderImage;